import { isAuthenticated } from "@store/action/auth";
import { useState, useCallback, useEffect, useMemo } from "react";
import { getUser, updateUserOnLocal } from "@store/action/user";
import { getOpenCourier } from "@store/action/openCourier";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function useIntegration() {
  const history = useHistory();

  /** @type {[import("@store/action/user").User, function]} */
  const [user, setUser] = useState(null);
  /** @type {[import("@store/action/openCourier").OpenCourier|null, function]} */
  const [openCourier, setOpenCourier] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = useCallback(async () => {
    try {
      const { user, token } = isAuthenticated();
      if (user?.courier?.openCourierId) {
        setUser(user);
        return;
      }
      
      const result = await getUser(token);
      if (result.success) {
        updateUserOnLocal(result.data, () => {});
        setUser(result.data);
      } else {
        alert("Gagal mengambil data akun, silahkan refresh halaman");
      }
    } catch (error) {
      alert("Terjadi kesalahan saat mengambil data");
    } 
  }, []);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const fetchOpenCourier = useCallback(async (openCourierId) => {
    const openCourier = await getOpenCourier(openCourierId);
    if (openCourier) {
      setOpenCourier(openCourier);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!user) return;

    if (!user.courier?.openCourierId) {
      history.push("/overview?tab=profile");
      return;
    }

    fetchOpenCourier(user?.courier?.openCourierId);
  }, [fetchOpenCourier, user, history]);

  return {
    openCourier,
    loading,
  }
}